import { Form } from '@aspendental/shared-forms-web';
import { styled } from '@mui/material/styles';

export const CustomForm = styled(Form)(() => ({
	display: 'flex',
	flex: 3,
	width: '100%',
	gap: '1.875rem',
	justifyItems: 'space-apart',
	flexDirection: 'column',
	alignItems: 'center',
}));

export const sendLinkButtonWrapper = {
	flex: 1,
	display: 'flex',
};
export const sendLinkButton = {
	padding: '1rem 1.5rem',
	alignSelf: 'flex-end',
};

export const descriptionText = {
	paddingBottom: '1rem',
};
